import script from "./location-autosuggest-alg.vue?vue&type=script&lang=jsx&setup=true"
export * from "./location-autosuggest-alg.vue?vue&type=script&lang=jsx&setup=true"

import "./location-autosuggest-alg.vue?vue&type=style&index=0&id=adeb777c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adeb777c"]])

export default __exports__